import { GraphicElement } from './GraphicElement';
import { Position } from '../Transform/Position';
import { Size } from '../Size';
import { Group } from './Group';
import { Scale } from '../Transform/Scale';
import { Rotation } from '../Transform/Rotation';
export class Theme extends Group {
    constructor(
        engine,
        content = [],
        pos = new Position(),
        uuid = GraphicElement.generateUUID(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        super(engine, uuid, pos, size, options, scale, rotation);
        this.type = 'Theme';
        this._content = content;
        this.isDuplicated = false;
        this.transform.isMovable = false;
    }
    get canBeSelected() {
        return true;
    }
    set engine(engine) {
        this._engine = engine;
        this.transform._engine = engine;
        for (const handle of this._handles) {
            handle._engine = engine;
        }
        this.content.forEach((el) => {
            el.engine = engine;
        });
    }
    // TODO finir hydrate avec les pos, scale, rotation
    static hydrate(data) {
        const theme = new Theme(
            data._engine,
            data._content,
            new Position(data.transform._pos._x, data.transform._pos._y),
            data._uuid
        );
        theme.transform.moveTo(new Position(data.transform._pos._x, data.transform._pos._y), true);
        theme.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY), true);
        theme.transform.rotate(data.transform._rotation._angle, true);
        theme.originSize = new Size(data.originSize._width, data.originSize._height);
        theme.colorGroups = data._colorGroups;
        theme.options = data.options;
        theme.visible = data.visible;
        return theme;
    }
}
